import * as React from 'react';

const Euro = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={40}
        height={40}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 40 40"
        {...props}
    >
        <path d="M24.286 28a7.4 7.4 0 0 1-2.857.571A8.23 8.23 0 0 1 13.572 20a8.23 8.23 0 0 1 7.857-8.571c.795.005 1.585.13 2.343.371M10 17.143h8.571M10 22.857h8.571" />
        <path d="M20 38.571c10.257 0 18.572-8.314 18.572-18.571S30.257 1.429 20 1.429 1.429 9.743 1.429 20 9.743 38.571 20 38.571" />
    </svg>
);
export default Euro;
